<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
  <path fill="#000" fill-rule="evenodd" d="M8.25 9.291h1.607V7.684c0-.71.017-1.803.517-2.48C10.901 4.487 11.624 4 12.869 4c2.027 0 2.881.297 2.881.297l-.402 2.451s-.67-.2-1.294-.2c-.625 0-1.185.231-1.185.874v1.87h2.563l-.179 2.393h-2.384V20H9.857v-8.315H8.25V9.29z" clip-rule="evenodd"/>
</svg>
